import { constructEnum } from '@/lib/enum';

export default constructEnum('ProductListDisplayField', {
  CATEGORY: 1,
  SORT: 2,
  ADVANCED_SEARCH: 4,
  PRICE_RANGE: 8
});
